import React, { useContext } from 'react';
import { Button, Modal, ModalOverlay, ModalHeader, ModalCloseButton, ModalBody, ModalContent, ModalFooter } from '@chakra-ui/react';
import { useMutation } from '@apollo/client';
import moment from 'moment';
import get from 'lodash/get';
import * as Yup from 'yup';
import { Formik, Form } from 'formik';

import SpinnerContext from '../../../contexts/SpinnerContext';
import { useCustomToast } from '../../../hooks/useCustomToast';
import UserContext from '../../../contexts/UserContext';
import { QuillInput } from '../../QuillInput';
import { UPDATE_ORDER } from '../query';

const CancelOrderSchema = Yup.object().shape({
  comment: Yup.string().required('Du musst einen Kommentar hinterlegen'),
});

export const StatusExpiredModal = ({ refetch, isOpen, onClose, orderId }) => {
  const { toggleSpinner } = useContext(SpinnerContext);
  const { user } = useContext(UserContext);
  const toast = useCustomToast();
  const [updateOrderStatus] = useMutation(UPDATE_ORDER);

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Buchung ist abgelaufen</ModalHeader>
          <Formik
            initialValues={{
              orderId,
              internalUser: user.id,
              comment: '',
            }}
            validationSchema={CancelOrderSchema}
            onSubmit={async ({ orderId, comment, internalUser }) => {
              try {
                toggleSpinner(true);

                await updateOrderStatus({
                  variables: {
                    orderId,
                    internalUser,
                    type: 'STATUS_CHANGED',
                    comment,
                    status: 'EXPIRED',
                  },
                });

                await refetch();

                toast({
                  title: 'Erfolg!',
                  description: 'Status wurde erfolgreich geändert!',
                  status: 'success',
                  isClosable: false,
                  duration: 3000,
                });
                toggleSpinner(false);
                onClose();
              } catch (error) {
                console.log(error);
                toast({
                  description: get(error, 'graphQLErrors.0.message', 'Ein Fehler ist aufgetreten!'),
                  status: 'error',
                });
                toggleSpinner(false);
              }
            }}>
            {({ isValid, dirty }) => (
              <Form>
                <ModalBody>
                  <QuillInput
                    placeholder="Geben Sie hier Ihre Beschreibung ein "
                    label="Warum möchtest du die Buchung auf Abgelaufen setzen?"
                    name="comment"
                  />
                </ModalBody>

                <ModalFooter>
                  <Button variant="ghost" size="sm" colorScheme="red" type="button" onClick={onClose}>
                    Abbrechen
                  </Button>

                  <Button disabled={!(isValid && dirty)} ml="4" size="sm" colorScheme="brand" type="submit">
                    Status ändern
                  </Button>
                </ModalFooter>
              </Form>
            )}
          </Formik>
          <ModalCloseButton />
        </ModalContent>
      </Modal>
    </>
  );
};
